export type TagType = "static" | "dynamic";

export interface CustomerTagItem {
  id: string;
  name: string;
  type: TagType;
  customerId: string;
  color?: string;
}

/**
 * Tags are now fetched from the real API via tagsApi.ts.
 * This function returns an empty array - callers should use
 * the tags API directly or the useTags hooks instead.
 */
export const getTagsByCustomerId = (_customerId: string): CustomerTagItem[] => {
  return [];
};
